import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
    dob: Yup.string()
        .nullable()
        .test("valid-date", "Invalid date", function(value) {
            if (value) return isValidDate(value);
            else return true;
        })
        .test("future-date", "Future dates are not allowed", function(value) {
            if (value) return isNotFutureDate(value);
            else return true;
        }),
    filterUCI: Yup.number()
        .notRequired()
        .nullable()
        .integer("Invalid")
        .typeError("Invalid"),
    lastFourOfSsn: Yup.string()
        .nullable()
        .notRequired()
        .test("is-valid-ssn", "invalid", value => value === "" || value == null || value?.length === 9),
    encounterStartDate: Yup.string()
        .nullable()
        .test("valid-date", "Invalid date", function(value) {
            if (value) return isValidDate(value);
            else return true;
        })
        .test("future-date", "Future dates are not allowed", function(value) {
            if (value) return isNotFutureDate(value);
            else return true;
        })
        .test("date-range", "Start date must be before end date", function(value) {
            if (value && encounterEndDate.value) return compareDates(value, encounterEndDate.value);
            else return true;
        }),
    encounterEndDate: Yup.string()
        .nullable()
        .test("valid-date", "Invalid date", function(value) {
            if (value) return isValidDate(value);
            else return true;
        })
        .test("future-date", "Future dates are not allowed", function(value) {
            if (value) return isNotFutureDate(value);
            else return true;
        })
        .test("date-range", "End date must be after start date", function(value) {
            if (value && encounterStartDate.value) return compareDates(encounterStartDate.value, value);
            else return true;
        }),
    phoneNumber: Yup.string()
        .min(10, "Invalid")
        .max(10, "Invalid"),
});
